// performance-log.ts
var logPerformanceOf = (name, func) => {
  return (...params) => {
    const startTime = Date.now();
    const logTime = () => {
      const durationTime = Date.now() - startTime;
      const reset = "\x1B[0m";
      const red = "\x1B[31m";
      const yellow = "\x1B[33m";
      const green = "\x1B[32m";
      console.log(
        `${durationTime < 300 ? green : durationTime < 600 ? yellow : red} ${name} took ${Date.now() - startTime} ${reset}`
      );
    };
    const functionResult = func(...params);
    if (functionResult instanceof Promise) {
      return functionResult.then((result) => {
        logTime();
        return result;
      });
    }
    logTime();
    return functionResult;
  };
};
export {
  logPerformanceOf
};
